import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '@/features/auth/pages/login-page'

export const Route = createFileRoute('/login')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { error?: string; returnTo?: string } => ({
    ...(typeof search.error === 'string' ? { error: search.error } : {}),
    ...(typeof search.returnTo === 'string'
      ? { returnTo: search.returnTo }
      : {}),
  }),
  component: LoginPage,
})
